module.exports = __webpack_public_path__ + "img/organization.1115006e.png";